// French translations
const fr = {
  nav: {
    home: "Accueil",
    projects: "Projets",
    about: "À propos",
  },
  home: {
    greeting: "Bonjour, je suis",
    name: "Tommy BOUBAKER",
    role: "Développeur Fullstack",
    pitch:
      "Je conçois des applications web robustes et évolutives — des APIs réfléchies aux interfaces soignées au pixel. Code propre, solutions pragmatiques, résultats concrets.",
    cta_projects: "Voir les projets",
    cta_about: "En savoir plus",
    skills_title: "Stack principale",
    featured_title: "Projets en vedette",
    featured_cta: "Voir tous les projets →",
  },
  projects: {
    title: "Projets",
    subtitle: "Une sélection de ce que j'ai créé.",
    view_detail: "Voir les détails →",
    back: "← Retour aux projets",
  },
  project_detail: {
    live_link: "Démo en ligne",
    github_link: "GitHub",
    back: "← Retour aux projets",
  },
  about: {
    title: "À propos de moi",
    subtitle: "Développeur, créateur, résolveur de problèmes.",
    bio_1: `Ancien boulanger, passioné d’informatique depuis l’enfance, j'ai décidé de suivre une reconversion professionnelle pour devenir développeur.
            Un premier apprentissage en autodidacte des langages Python et C# m'a permis de confirmer mon intérêt pour la programmation et de me familiariser avec les concepts de base du développement.`,
    bio_2: `J'ai ensuite décidé de me former professionnellement, en suivant une formation certifiante d'abord avec l'AFPA Territoire digital pour obtenir un diplôme de développeur web et web mobile, puis avec Diginamic pour obtenir un diplôme de concepteur développeur d'applications. Ces formations m'ont permis d'acquérir des compétences solides en développement web, en travaillant sur des projets concrets et en utilisant des technologies modernes.`,
    bio_3:
      "J'ai aujourd'hui la certitude d'avoir fait le bon choix de carrière et souhaite continuer de progresser dans ce domaine. Je me soucie d'écrire du code maintenable, de collaborer avec de bonnes équipes et de livrer des produits qui font une différence. Actuellement ouvert à de nouvelles opportunités.",
    skills_title: "Compétences",
    experience_title: "Expérience",
    education_title: "Diplômes et formation",
    download_cv: "Télécharger le CV (PDF)",
    degrees: [
      {
        title:
          "Titre professionnel Concepteur développeur d'applications niveau 6 (Bac +3)",
        institution: "Diginamic - Montpellier",
        period: "2025 – 2026",
      },
      {
        title:
          "Titre professionnel Développeur web et web mobile niveau 5 (Bac +2)",
        institution: "AFPA Territoire digital",
        period: "2023 – 2024",
      },
    ],
    exp: [
      {
        role: "Développeur Fullstack (stagiaire)",
        company: "Plan & Joy",
        period: "Décembre 2025 – mars 2026",
        desc: `Collaboration sur une application multi usages pour les restaurants (prise de
              réservation, commandes à emporter ...) et d’un standardiste IA. 
              Collaboration avec Git et Github.
              Développement back-end avec Node.js.
              Développement front-end avec Nuxt.js.`,
      },
      {
        role: "Développeur web Junior (stagiaire)",
        company: "NOUS - Ouvert, Utile et Simple",
        period: "mai 2024 – juillet 2024",
        desc: `Collaboration sur une application de gestion de formations dans le cadre de ma
              formation de développeur web. 
              Version control avec Git et Gitlab.
              Développement front-end avec React.js.
              Développement de la partie back-end avec Symfony.
              Développement et maintenance de plugins Wordpress crées par l’entreprise.`,
      },
    ],
  },
  footer: {
    tagline: "Construit avec React · Disponible",
    contact: "Me contacter",
  },
  theme: {
    toggle_dark: "Mode sombre",
    toggle_light: "Mode clair",
  },
};

export default fr;
